export { Results } from "@/components/common/ResultsSliderBase/ResultsRoot";
